import { createContext, useContext } from "react";

import { Impulse } from "~/tools/impulse";
import { useRequiredContext } from "~/tools/use-required-context";

const WidgetContext = createContext<null | boolean>(null);

export const WidgetContextProvider = WidgetContext.Provider;

export const useIsWidgetExpandable = (): boolean =>
	useRequiredContext(WidgetContext, {
		providerName: "Widget",
	});

const WidgetExpandContext = createContext(Impulse(new Map<string, boolean>()));

export const WidgetExpandContextProvider = WidgetExpandContext.Provider;

export const useWidgetExpandContext = (): Impulse<Map<string, boolean>> => useContext(WidgetExpandContext);
